var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M405.333,266.667    c0,5.896-4.771,10.667-10.667,10.667H277.333v117.333c0,5.896-4.771,10.667-10.667,10.667h-21.333    c-5.896,0-10.667-4.771-10.667-10.667V277.333H117.333c-5.896,0-10.667-4.771-10.667-10.667v-21.333    c0-5.896,4.771-10.667,10.667-10.667h117.333V117.333c0-5.896,4.771-10.667,10.667-10.667h21.333    c5.896,0,10.667,4.771,10.667,10.667v117.333h117.333c5.896,0,10.667,4.771,10.667,10.667V266.667z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#528AEA"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.0c35eb9c2a5a801e506355fe1bebafc8.svg";
export { ForwardRef as ReactComponent };